import { CategoryParams } from 'types/getParams';
import { ResourceCategoryParams } from 'types/resourceCategory';

import { CRMAPIBase } from '@api/crmApiBase';
import { RequestResult } from '@api/responseModels/requestResult';
import { ResourceCategoryListResp } from '@api/responseModels/resource/resourceCategoryListResponse';
import { ResourceCategoryResp } from '@api/responseModels/resource/resourceCategoryResponse';

export class ResourceCategoryGroup extends CRMAPIBase {
    async getResourceCategoryList(
        params: CategoryParams
    ): Promise<RequestResult<ResourceCategoryListResp>> {
        const result = await this.get<ResourceCategoryListResp>('/resource-categories', params);
        return result;
    }

    async getResourceCategory(
        id: number,
        crm_id: number,
        resource_type?: string
    ): Promise<RequestResult<ResourceCategoryResp>> {
        const result = await this.get<ResourceCategoryResp>(`/resource-categories/${id}`, {
            crm_id,
            resource_type,
        });
        return result;
    }

    async getAllIncludedResourceCategories(
        crmId: number,
        categoryId: number
    ): Promise<RequestResult<any>> {
        const result = await this.get<any>(`/resource-categories/${categoryId}/categories`, {
            crm_id: crmId,
        });
        return result;
    }

    async createResourceCategory(
        params: ResourceCategoryParams
    ): Promise<RequestResult<ResourceCategoryListResp>> {
        const result = await this.post<ResourceCategoryListResp>('/resource-categories', params);
        return result;
    }

    async updateResourceCategory(
        id: number,
        params: ResourceCategoryParams
    ): Promise<RequestResult<ResourceCategoryListResp>> {
        const result = await this.put<ResourceCategoryListResp>(
            `/resource-categories/${id}`,
            params
        );
        return result;
    }

    async updateResourceParentCategories(
        crmId: number,
        resourceCategories: Array<{ id: number; parent_resource_category_id: number }>
    ): Promise<RequestResult<any>> {
        const result = await this.post<any>('/resource-categories/update/bulk', {
            crm_id: crmId,
            resource_categories: resourceCategories,
        });
        return result;
    }

    async deleteResourceCategory(id: number): Promise<RequestResult<ResourceCategoryListResp>> {
        const result = await this.delete<ResourceCategoryListResp>(`/resource-categories/${id}`);
        return result;
    }
}
